module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_5_2-829147e86abd278bac9da6855fb21c4f.png";